import React from 'react'
import { useTranslate } from './TranslationText'

export default function HorseResultsTable({ showbyIdData, showsLoading, showClassHorseSoringDetailsData, item3 }) {
    const { translate } = useTranslate();

    return (
        <div className="col-md-12 px-0 scrolableTable ">
            <table className="table table-striped table-bordered">
                <thead
                    className="text-white"
                >
                    <tr>
                        <th className=""></th>
                        <th className="text-right-rtl">
                            {translate(
                                "web.type",
                                "Type"
                            )}
                        </th>
                        {!!showbyIdData &&
                            !showsLoading &&
                            showbyIdData?.isHeadNeakType && (
                                <React.Fragment>
                                    <th className="text-right-rtl">
                                        {translate(
                                            "web.head",
                                            "Head"
                                        )}
                                    </th>
                                    <th className="text-right-rtl">
                                        {translate(
                                            "web.neck",
                                            "Neck"
                                        )}
                                    </th>
                                </React.Fragment>
                            )}
                        <th className="text-right-rtl">
                            {translate(
                                "web.hn",
                                "H&N"
                            )}
                        </th>
                        <th className="text-right-rtl">
                            {translate(
                                "web.body",
                                "Body"
                            )}
                        </th>
                        <th className="text-right-rtl">
                            {translate(
                                "web.legs",
                                "Legs"
                            )}
                        </th>
                        <th className="text-right-rtl">
                            {translate(
                                "web.movement",
                                "Movement"
                            )}
                        </th>
                        <th className="text-center bold">
                            {translate(
                                "web.totalPoints",
                                "Total Points"
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {!!showClassHorseSoringDetailsData?.scoringTable &&
                        showClassHorseSoringDetailsData?.scoringTable.length >
                        0 ? (
                        showClassHorseSoringDetailsData?.scoringTable.map(
                            (
                                itemScoring,
                                iScoring
                            ) => (
                                <tr key={iScoring} className="fw-bold">
                                    <td className="text-white text-center" style={{ background: `var(--bgGray)` }}>
                                        {itemScoring.judgeLetter}
                                    </td>
                                    <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring.type}
                                    </td>
                                    {!!showbyIdData &&
                                        !showsLoading &&
                                        showbyIdData?.isHeadNeakType && (
                                            <React.Fragment>
                                                <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                                    {itemScoring.head}
                                                </td>
                                                <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                                    {itemScoring.neck}
                                                </td>
                                            </React.Fragment>
                                        )}
                                    <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring.headNeck}
                                    </td>
                                    <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring.body}
                                    </td>
                                    <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring.leg}
                                    </td>
                                    <td style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring.move}
                                    </td>
                                    {iScoring ===
                                        0 && (
                                            <td
                                                className="fw-bold text-white"
                                                rowSpan={showClassHorseSoringDetailsData?.scoringTable?.length}
                                                style={{
                                                    background: `var(--bgGray)`,
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <span>
                                                    {item3.totalPoint}
                                                </span>
                                                <br />
                                                <span>
                                                    {translate(
                                                        "web.points",
                                                        "POINTS"
                                                    )}
                                                </span>
                                            </td>
                                        )}
                                </tr>
                            )
                        )
                    ) : (
                        <tr>
                            <td
                                colSpan={!!showbyIdData &&
                                    !showsLoading &&
                                    showbyIdData?.isHeadNeakType
                                    ? 9
                                    : 7}
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                <span className="text-danger text-center">
                                    {translate(
                                        "web.nodataFound",
                                        "No Data Found !"
                                    )}
                                </span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <sub className="ms-3 fw-bold rtl">
                {translate('web.judges', 'Judges')}: {showClassHorseSoringDetailsData?.scoringTable?.map((item, index) => (`${item?.judgeLetter} - ${item?.judgeName}${(index !== showClassHorseSoringDetailsData?.scoringTable?.length) && ` , `} `))}
            </sub>
        </div>
    )
}
